import { useEffect, useState } from "react";

export function ZoneChart({title='', zone}) {

    const[data, setData] = useState({
        ozone: [0, 0, 0, 0], 
        ozonePR: [0, 0, 0, 0], 
        zone: [0, 0, 0, 0, 0, 0, 0, 0, 0], 
        zonePR: [0, 0, 0, 0, 0, 0, 0, 0, 0] 
        // ozone: [35, 32, 60, 42],
        // ozonePR: [92, 96, 63, 86],
        // zone: [8, 12, 37, 53, 57, 36, 25, 21, 15],
        // zonePR: [73, 56, 48, 35, 27, 13, 9, 89, 72],
    })


    useEffect(()=>{
        if(zone !== null){
            // console.log(zone)
            setData(zone)
        }
    },[zone])


    function setZoneItem(index, val, pr){
        // console.log(index)
        var color = parseInt(pr/10)
        if(isNaN(color))
            color = 1
            else color +=1
        return <div className={"zone"+index + " zone_color"+color} >{parseInt(val*10)/10}</div>
    }

    // console.log(data)
    return (
        <div className="chart_zone">
            <div className="chart_zone_title">{title}</div>
            <div className="chart_zone_block">
                {
                    data.ozone.map((v, z)=>{
                        return setZoneItem((parseInt(z)+1), v, data.ozonePR[z])
                    })
                }
                <div className="zone_middle">
                {
                    data.zone.map((v, z)=>{
                        return setZoneItem((parseInt(z)+5), v, data.zonePR[z])
                    })
                }
                </div>
            </div>
        </div>
    )
}